export const LicensePropKeys = {
    SToneProgrammability: 'stone-programmability',
    // FreeText: 'free-text',
}